import { message } from 'antd'
import {
  RSetState,
  NInfo,
  EGetInfo,
  EPostInfo,
  EGetTopic,
  RTopic,
  RCategory,
  RSetInfoItem,
  EPostVisitInfo,
  EPostCollectInfo,
  EGetInfoDetail,
  RSetInfoList,
  RInfoDetail,
  EGetCategory,
  EPostLikeInfo,
  EGetSearch,
  EGetHotSearch,
  EGetVisitInfo,
} from './constants'
import _ from 'lodash'
import {
  getInfo,
  postInfo,
  getSearch,
  getTopic,
  getInfoDetail,
  postVisitInfo,
  postCollectInfo,
  getCategory,
  postLikeInfo,
  getHot,
  getVisit,
} from '../services'

export default {
  namespace: NInfo,
  state: {
    infoList: {
      data: [],
      lastPage: null,
    },
    categoryID: 1,
    pager: 1,
    start: false,
    topic: [],
    category: [],
    topicID: null,
    loading: false,
    infoDetail: {
      user: {},
    },
    searchList: {
      data: [],
      total: 0,
      pager: 1,
    },
    searchCategoryCount: [],
    infoVisit: null,
    isGetCategory: false,
  },
  reducers: {
    [RSetState](state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
    [RTopic](state, { payload }) {
      return {
        ...state,
        topic: payload,
      }
    },
    [RCategory](state, { payload }) {
      return {
        ...state,
        category: payload,
      }
    },
    [RInfoDetail](state, { payload }) {
      return {
        ...state,
        infoDetail: payload,
      }
    },
    [RSetInfoItem](state, { payload }){
      let { infoList } = state
      if(payload){
        let old = _.find(infoList.data, { id: payload.id })
        if(old){
          _.assign(old, payload)
        }
      }
      return {
        ...state,
        infoList: _.cloneDeep(infoList)
      }
    },
    [RSetInfoList](state, { payload }){
      let { infoList } = state
      if(infoList&&infoList.data.length!==0){
        infoList.lastPage = payload.lastPage
        infoList.data = infoList.data.concat(payload.data)
      }else{
        infoList = payload
      }
      return {
        ...state,
        infoList: _.cloneDeep(infoList)
      }
    }
  },
  effects: {
    async [EGetInfo]({ payload }, { call, reducer, select }) {
      // console.log(select(NInfo),'fffffffffffffffff')
      let { pager, start, infoList, categoryID, topicID, loading } = select(NInfo)
      let seesionPage = sessionStorage.getItem(`categoryID${categoryID}`)
      if (loading) {
        return
      }
      let page = 1
      if (+categoryID === 1) {
        if (pager < infoList.lastPage) {
          page = pager + 1
        } else if (pager === infoList.lastPage) {
          page = infoList.lastPage
        }
      } else {
        page = pager
      }
      if (start) {
        page = 1
        topicID = undefined
        if (seesionPage) {
          page = seesionPage
        }
      }
      let infoLists = await call(getInfo, { page, perPage: 6, topicID, categoryID })
      if(categoryID === 1){
        reducer(RSetInfoList, infoLists)
      }else{
        reducer(RSetState, { infoList: infoLists })
      }
      reducer(RSetState, { start: false, loading: false, pager: page })
    },
    async [EPostInfo]({ payload }, { call, reducer, select }) {
      await call(postInfo, payload)
      message.success('发布成功，等待审核通过')
      if (Number(payload.categoryID) === 1) {
        window.location.href = '#/'
      } else if (Number(payload.categoryID) === 2) {
        window.location.href = '#/aspirations'
      } else if (Number(payload.categoryID) === 3) {
        window.location.href = '#/emperor'
      } else {
        window.location.href = `#/aspirations?id=${payload.categoryID}`
      }
    },

    async [EGetTopic]({ payload }, { call, reducer, select }) {
      let data = await call(getTopic, payload)
      reducer(RTopic, data)
    },
    async [EGetCategory]({ payload }, { call, reducer, select }) {
      reducer(RSetState, { isGetCategory: false })
      let data = await call(getCategory, payload)
      reducer(RCategory, data)
      reducer(RSetState, { isGetCategory: true })
    },

    async [EGetInfoDetail]({ payload }, { call, reducer, select }) {
      let data = await call(getInfoDetail, payload)
      reducer(RInfoDetail, data)
    },
    async [EPostVisitInfo]({ payload }, { call, reducer, select }) {
      let data = await call(postVisitInfo, payload)
      reducer(RInfoDetail, data)
    },
    async [EPostCollectInfo]({ payload }, { call, reducer, select }) {
      let data = await call(postCollectInfo, payload)
      reducer(RInfoDetail, data)
    },
    async [EPostLikeInfo]({ payload }, { call, reducer, select, effect }) {
      let data = await call(postLikeInfo, payload)
      reducer(RSetInfoItem, data)
      // effect(NInfo, EGetInfoDetail, payload)
    },

    async [EGetSearch]({ payload }, { call, reducer, select, effect }) {
      const { result, categoryCount } = await call(getSearch, payload)
      if (payload.type) {
        reducer(RSetState, { infoList: result, start: false, loading: false })
      } else {
        reducer(RSetState, { searchList: result, searchCategoryCount: categoryCount })
      }
    },
    //获取热门帖
    async [EGetHotSearch]({ payload }, { call, reducer }) {
      const result = await call(getHot, payload)
      reducer(RSetState, { hotList: result })
    },
    //获取帖子浏览
    async [EGetVisitInfo]({ payload }, { call, reducer }) {
      const result = await call(getVisit, payload)
      reducer(RSetState, { infoVisit: result })
    },
  },
}
